module.exports = __webpack_public_path__ + "static/img/ARAD1S_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD1S_2.png
// module id = JmwU
// module chunks = 0